export const API_URL = import.meta.env.VITE_API_URL as string;
export const API_HOST_NAME = import.meta.env.VITE_HOST_NAME as string;
export const ASSETS_BUCKET_URL = import.meta.env.VITE_ASSETS_BUCKET_URL as string;
export const CLIENT_ID = '7da036ae8f2ff72ca6bf2a6e839db937' as string;
export const CLIENT_SECRET = 'cadf4ac9c6d882ea919c89dbefdfc3d8' as string;
export const GRANT_TYPE = 'password' as string;
export const XVERSION = '7.0.0' as string;
export const XORIGIN = 'mweb' as string;
export const UPI_INTENT_TIMEOUT = import.meta.env.VITE_UPI_TIMEOUT ?? (5000 as number);
